import { render, staticRenderFns } from "./InputSigarusFileDrag.vue?vue&type=template&id=70b10320"
import script from "./InputSigarusFileDrag.vue?vue&type=script&lang=js"
export * from "./InputSigarusFileDrag.vue?vue&type=script&lang=js"
import style0 from "./InputSigarusFileDrag.vue?vue&type=style&index=0&id=70b10320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports